import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { log } from 'console';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';

import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { LayoutService } from 'src/app/services/layout.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { UtilService } from 'src/app/services/util.service';

import {
  LayoutFile,
  LayoutImage,
  UploadLayout,
} from 'src/app/models/settings.model';
declare const $: any;

@Component({
  selector: 'app-custom-css',
  templateUrl: './custom-css.component.html',
  styleUrls: ['./custom-css.component.scss'],
})
export class ViewCustomCssComponent implements OnInit {
  @ViewChildren('hidewhenloading') hidewhenloading: QueryList<ElementRef>;
  customCss: UploadLayout = {
    URLRegex: '',
    File: undefined,
    FileName: '',
    SchoolId: 0,
    Description: '',
  };
  adminActions: AdminAction[] = [];
  fileToDelete: LayoutFile = {
    id: 0,
    description: '',
    urlRegex: '',
    filePath: '',
    safeUrl: undefined,
    loaded: false,
    fileName: '',
    fileurl: '',
  };
  imageToDelete: LayoutImage = {
    id: 0,
    filePath: '',
    fileName: '',
    safeUrl: undefined,
  };
  schId: number;
  fileList: FileList;
  customCssFiles: Array<LayoutFile> = [];
  customlayoutImages: Array<LayoutImage> = [];
  constructor(
    public headerinfo: ComponentheaderService,
    public schoolservice: SchoolmanagementService,
    public toastr: ToastrService,
    public util: UtilService,
    public moduleservice: ModulemanagementService,
    private layoutService: LayoutService,
    private sanitizer: DomSanitizer
  ) {}

  async ngOnInit() {
    try {
      this.headerinfo.pageLoadingStarted(this);
      const school: any = await this.schoolservice.getSchoolFromSubdomain();

      this.schId = school.id;
      this.customCss.SchoolId = this.schId;
      this.adminActions = [
        {
          displaytext: 'Add Custiom CSS',
          callback: this.popCssFileUpload.bind(this),
          classes: ['fas', 'fas fa-file-code'],
        },
        {
          displaytext: 'Add images',
          callback: this.popImgUpload.bind(this),
          classes: ['fas', 'far fa-file-image'],
        },
        {
          displaytext: 'View images',
          callback: this.popImgView.bind(this),
          classes: ['fas', 'fa-folder-open'],
        },
      ];

      this.customCssFiles = await this.layoutService
        .getLayouts(school.id)
        .then((res: any) => {
          return res;
        });
      console.log(this.customCssFiles);

      this.headerinfo.setHeaderDisplay(
        'Custom CSS Files',
        [
          {
            displaytext: 'School',
            route: '/user/schoolhome',
          },
          {
            displaytext: 'Custom CSS Files',
            route: `/customisation/css`,
          },
        ],
        this.adminActions
      );
    } catch (error) {
    } finally {
      this.headerinfo.pageLoadingDone(this);
    }
  }

  popCssFileUpload() {
    $('#uploadCSSFile').modal('show');
  }

  popCssFileDelete(file: any) {
    this.fileToDelete = file;
    $('#deleteCssFile').modal('show');
  }

  popImgUpload() {
    $('#uploadImgFile').modal('show');
  }

  async popImgView() {
    try {
      this.customlayoutImages = await this.layoutService
        .getLayoutImages(this.schId)
        .then((res: any) => {
          return res;
        });
      console.log(this.customCssFiles);
      $('#viewImgs').modal('show');
    } catch (error) {}
  }

  popImageDelete(file: any) {
    this.imageToDelete = file;
    console.log(this.imageToDelete);
    $('#viewImgs').modal('hide');
    $('#deleteImg').modal('show');
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.customCss.FileName = file.name;
      this.customCss.File = file;
    }
  }

  async uploadCssFile() {
    try {
      if (!this.checkModelValid()) {
        return;
      }
      this.headerinfo.pageLoadingStarted(this);

      let formData = new FormData();
      formData.append('File', this.customCss.File);
      formData.append('FileName', this.customCss.FileName);
      formData.append('Description', this.customCss.Description);
      formData.append('SchoolId', '' + this.customCss.SchoolId);
      formData.append('URLRegex', this.customCss.URLRegex);
      await this.layoutService.UploadLayoutFile(formData).then((res: any) => {
        this.toastr.success('File Uploaded');
        window.location.reload();
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.headerinfo.pageLoadingDone(this);
    }
  }

  checkModelValid() {
    if (this.customCss.File == undefined) {
      this.toastr.error('No file selected');
      return false;
    }
    if (
      this.customCss.Description == '' ||
      this.customCss.Description == undefined
    ) {
      this.toastr.error('Description required');
      return false;
    }
    if (this.customCss.URLRegex == '' || this.customCss.URLRegex == undefined) {
      this.toastr.error('URL Regex required');
      return false;
    }
    if (this.customCss.SchoolId == 0) {
      this.toastr.error('Invalid request.');
      window.location.assign('login');
      return false;
    }
    return true;
  }

  deleteFile() {
    this.layoutService.deleteLayout(this.fileToDelete.id).then(() => {
      this.toastr.success('Deleted');
      window.location.reload();
    });
  }

  getSafeUrl(url: any) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  onImageFileChange(event: any) {
    this.fileList = event.target.files;
    console.log(this.fileList);
  }

  async uploadImgs() {
    if (this.fileList == undefined || this.fileList.length <= 0) {
      this.toastr.error('Please select Images');
      return;
    }

    try {
      this.headerinfo.pageLoadingStarted(this);
      const formData = new FormData();
      // Append each image to the FormData object
      for (let i = 0; i < this.fileList.length; i++) {
        formData.append('images', this.fileList[i]);
      }
      await this.layoutService.UploadImgFiles(formData).then(() => {
        this.toastr.success('Images Uploaded');
        window.location.reload();
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.headerinfo.pageLoadingDone(this);
    }
  }

  deleteImg() {
    this.layoutService.deleteLayoutImage(this.imageToDelete.id).then(() => {
      $('#deleteImg').modal('hide');
      this.toastr.success('Deleted');
    });
  }
}
